/** The "Order:" pin for one option of a randomised list — docs/adr/0009. Shared by every editor that randomises. */
import type { ChoiceAnchor } from './choicePresentation';

const ANYWHERE = 'none';
const ANCHOR_OPTIONS = [
  [ANYWHERE, 'Anywhere'],
  ['top', 'Pin to top'],
  ['bottom', 'Pin to bottom'],
] as const;

interface ChoiceAnchorSelectProps {
  id: string;
  value: ChoiceAnchor | undefined;
  onChange: (anchor: ChoiceAnchor | undefined) => void;
}

export function ChoiceAnchorSelect({ id, value, onChange }: ChoiceAnchorSelectProps) {
  return (
    <div className="ml-10 flex items-center space-x-2">
      <label className="text-xs text-gray-600 min-w-fit" htmlFor={id}>
        Order:
      </label>
      <select
        id={id}
        value={value ?? ANYWHERE}
        onChange={(e) =>
          onChange(e.target.value === ANYWHERE ? undefined : (e.target.value as ChoiceAnchor))
        }
        className="px-2 py-1 border border-gray-300 rounded text-xs"
      >
        {ANCHOR_OPTIONS.map(([optionValue, label]) => (
          <option key={optionValue} value={optionValue}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
}
